// src/stone/icons/Star24.tsx
import { jsx } from "react/jsx-runtime";
var Star24 = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M20 2.334a1 1 0 0 1 .897.557l4.917 9.963 10.997 1.607a1 1 0 0 1 .553 1.706l-7.956 7.75 1.878 10.948a1 1 0 0 1-1.451 1.054L20 30.747l-9.834 5.172a1 1 0 0 1-1.452-1.054l1.878-10.948-7.956-7.75a1 1 0 0 1 .553-1.706l10.997-1.607 4.917-9.963A1 1 0 0 1 20 2.334m0 3.26-4.253 8.616a1 1 0 0 1-.752.547l-9.513 1.39 6.882 6.704a1 1 0 0 1 .288.885l-1.624 9.47 8.507-4.474a1 1 0 0 1 .93 0l8.507 4.474-1.624-9.47a1 1 0 0 1 .288-.885l6.882-6.704-9.513-1.39a1 1 0 0 1-.752-.547z" })
  }
);
var Star24_default = Star24;

export {
  Star24_default
};
